<div
  class="
    d-flex
    flex-column flex-grow-1
    bg-light
    chat-messages
    position-relative
  "
  *ngIf="{ showToolTip: showToolTip$ | async } as vm"
>
  <div
    class="d-flex flex-column chat-scroll pt-1"
    [perfectScrollbar]
    (psScrollUp)="stopAutoScroll($event)"
    (psYReachEnd)="startAutoScroll($event)"
  >
    <ng-container
      #chatMessages
      *ngFor="
        let msg of messages | orderBy: { field: 'messageId', order: 'asc' };
        trackBy: messageById
      "
    >
      <ng-container [ngSwitch]="msg.userId">
        <div
          *ngSwitchCase="0"
          class="d-flex flex-column align-items-start mt-2"
        >
          <ng-container [ngSwitch]="msg.data?.type">
            <lib-honour-board-message
              *ngSwitchCase="'honour-board'"
              [msg]="msg"
            ></lib-honour-board-message>
            <lib-ibqueue-handled-message
              *ngSwitchCase="'ibqueue-handled'"
              [msg]="msg"
            ></lib-ibqueue-handled-message>
            <lib-ibqueued-calls-message
              *ngSwitchCase="'ibqueue-calls'"
              [msg]="msg"
            ></lib-ibqueued-calls-message>
            <small class="text-muted text-right extra-small">
              <ng-container *ngIf="showGroup">
                ({{ msg.group }})&nbsp;&nbsp;&nbsp;
              </ng-container>
              {{ msg.sent | date: "h:mm a":"en-AU" }}
            </small>
          </ng-container>
        </div>
        <div
          *ngSwitchCase="currentUserId"
          class="d-flex flex-column align-items-end"
        >
          <span
            class="
              mt-2
              mb-0
              ml-4
              mr-0
              p-1
              border border-8 border-info
              bg-info
              text-white text-right
              small
            "
            innerHtml="{{ msg.message }}"
            [ngbTooltip]="vm.showToolTip ? messageMenuSelf : ''"
            placement="left auto"
            #tip="ngbTooltip"
            (mouseover)="vm.showToolTip && showTip(tip)"
            autoClose="outside"
            triggers="none"
            container="body"
          ></span>
          <ng-template #messageMenuSelf>
            <span class="cursor-pointer" (click)="pin(msg.messageId, tip)">
              <i
                class="fas fa-link"
                style="font-size: 10px; padding-top: 0px"
                aria-hidden="true"
              ></i>
            </span>
          </ng-template>
          <small class="text-muted text-right extra-small">
            <ng-container *ngIf="showGroup">
              ({{ msg.group }})&nbsp;&nbsp;&nbsp;
            </ng-container>

            {{ msg.sent | date: "h:mm a":"en-AU" }}
          </small>
        </div>
        <div *ngSwitchDefault class="d-flex flex-column align-items-start">
          <div class="d-flex flex-row align-items-start">
            <img
              [src]="msg.userId | userAvatar | async"
              [alt]="msg.userId | userName | async"
              [ngbTooltip]="vm.showToolTip ? confirmPersonal : ''"
              placement="right auto"
              #ctip="ngbTooltip"
              autoClose="outside"
              triggers="none"
              container="body"
              (mouseover)="vm.showToolTip && showPersonalTip(ctip)"
              class="mt-2 rounded-circle small-avatar"
              (click)="vm.showToolTip ? confirmPersonalTooltip(msg.userId) : ''"
            />

            <div class="d-flex flex-column">
              <span
                class="
                  mt-2
                  mb-0
                  mr-2
                  ml-0
                  p-1
                  border-8 border border-secondary
                  small
                "
                [ngClass]="{
                  'chat-supervisor': isChatSupervisor(msg.userId)
                }"
                innerHtml="{{ msg.message }}"
                [ngbTooltip]="vm.showToolTip ? messageMenu : ''"
                placement="right auto"
                #tip="ngbTooltip"
                (mouseover)="vm.showToolTip && showTip(tip)"
                autoClose="outside"
                triggers="none"
                container="body"
              >
              </span>
              <ng-template #messageMenu>
                <span class="cursor-pointer" (click)="pin(msg.messageId, tip)">
                  <i
                    class="fas fa-link"
                    style="font-size: 10px; padding-top: 0px"
                    aria-hidden="true"
                  ></i>
                </span>
              </ng-template>
              <ng-template #confirmPersonal>
                <span
                  class="cursor-pointer"
                  (click)="confirmPersonalTooltip(msg.userId)"
                >
                  <i
                    style="font-size: 10px; padding-top: 0px"
                    aria-hidden="true"
                    >Click to open Personal Chat</i
                  >
                </span>
              </ng-template>
            </div>
          </div>
          <small class="ml-31 text-muted extra-small">
            <ng-container *ngIf="showGroup">
              ({{ msg.group }})&nbsp;&nbsp;&nbsp;
            </ng-container>
            <ng-container *ngIf="showSettings">
              {{ msg.userId }} &nbsp;&nbsp;-&nbsp;&nbsp;
            </ng-container>
            {{ msg.userId | userName: "name" | async }}&nbsp;&nbsp;&nbsp;
            {{ msg.sent | date: "h:mm a" }}
          </small>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
